import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { ResponsePayload, Widget } from "@/types";
import { fetchWidget, fetchWidgets } from "./thunk";

export interface WidgetsState {
  widgets: Array<Partial<Widget>>;
  currentWidget: Partial<Widget> | null;
  meta: { count: number };
  status: "idle" | "fetching";
  error: string | null;
}

const initialState: WidgetsState = {
  widgets: [],
  currentWidget: null,
  meta: { count: 0 },
  status: "idle",
  error: null
};

export const widgetsSlice = createSlice({
  name: "widgets",
  initialState,
  reducers: {
    clearCurrentWidget: (state) => {
      state.currentWidget = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[widgetsSlice.name]
        };
      })
      .addCase(fetchWidgets.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchWidgets.fulfilled, (state, action) => {
        const { widgets, meta } = action.payload;

        state.status = "idle";
        state.widgets = widgets;
        state.meta = meta;
      })
      .addCase(fetchWidgets.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      })
      .addCase(fetchWidget.pending, (state) => {
        state.status = "fetching";
        state.error = null;
      })
      .addCase(fetchWidget.fulfilled, (state, action) => {
        state.status = "idle";
        state.currentWidget = action.payload.widget;
      })
      .addCase(fetchWidget.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.currentWidget = null;
        state.error = statusText;
      });
  }
});

export const { clearCurrentWidget } = widgetsSlice.actions;
